import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  dialog: {
    height: 366,
    width: 420,
  },
}));
